<template>
  <div class="settings-container" v-if="props.data">
    
      <div class="section-header" v-if="props.data.manageSettings">
        <h3>Manage settings</h3>
        <el-select v-if="props.canEdit" v-model="props.data.manageSettings.permission" default-first-option @change="handleManageChange">
          <el-option v-for="item in props.data.manageSettings.permissionOption" :key="item.type" :label="item.name"
            :value="item.type" />
        </el-select>
        <span v-else>{{ switchParentText(props.data.manageSettings.permission) }}</span>
      </div>
    
      <div class="setting-item indented" v-if="props.data.editCompanyNameAndLogo">
        <span>Edit company name & logo</span>
        <div v-if="props.data.manageSettings.permission === 100">
          <Switch v-if="props.canEdit" :checked="props.data.editCompanyNameAndLogo.permission === 100"
            @click.native="switchItem(props.data, 'editCompanyNameAndLogo.permission')" />
          <span v-else>{{ switchText(props.data.editCompanyNameAndLogo.permission) }}</span>
        </div>
      </div>

      <!-- header -->
      <div class="section-header section-header-2" v-if="props.data.teamSettings">
        <h3>Team settings</h3>
        <el-select v-if="props.canEdit" v-model="props.data.teamSettings.permission" default-first-option @change="handleTeamChange">
          <el-option v-for="item in props.data.teamSettings.permissionOption" :key="item.type" :label="item.name"
            :value="item.type" />
        </el-select>
        <span v-else>{{ switchParentText(props.data.teamSettings.permission) }}</span>
      </div>

      <div class="setting-item indented" v-if="props.data.inviteTeammates">
        <span>Invite members</span>
        <div v-if="props.data.teamSettings.permission === 100">
          <Switch v-if="props.canEdit" :checked="props.data.inviteTeammates.permission === 100"
            @click.native="switchItem(props.data, 'inviteTeammates.permission')" />
          <span v-else>{{ switchText(props.data.inviteTeammates.permission) }}</span>
        </div>
      </div>

      <div class="setting-item indented" v-if="props.data.assignRoleAndCompanyOrTeamToTeammates">
        <span>Assign role and company/team to members</span>
        <div v-if="props.data.teamSettings.permission === 100">
          <Switch v-if="props.canEdit" :checked="props.data.assignRoleAndCompanyOrTeamToTeammates.permission === 100"
            @click.native="switchItem(props.data, 'assignRoleAndCompanyOrTeamToTeammates.permission')" />
          <span v-else>{{ switchText(props.data.assignRoleAndCompanyOrTeamToTeammates.permission) }}</span>
        </div>
      </div>

      <div class="setting-item indented" v-if="props.data.manageTeammates">
        <span>Manage members</span>
        <div v-if="props.data.teamSettings.permission === 100">
          <Switch v-if="props.canEdit" :checked="props.data.manageTeammates.permission === 100"
            @click.native="switchItem(props.data, 'manageTeammates.permission')" />
          <span v-else>{{ switchText(props.data.manageTeammates.permission) }}</span>
        </div>
      </div>

      <div class="setting-item indented" v-if="props.data.createAndEditAndManageCustomCompanyOrTeam">
        <span>Create, edit and manage custom roles</span>
        <div v-if="props.data.teamSettings.permission === 100">
          <Switch v-if="props.canEdit" :checked="props.data.createAndEditAndManageCustomCompanyOrTeam.permission === 100"
            @click.native="switchItem(props.data, 'createAndEditAndManageCustomCompanyOrTeam.permission')" />
          <span v-else>{{ switchText(props.data.createAndEditAndManageCustomCompanyOrTeam.permission) }}</span>
        </div>
      </div>

      <div class="setting-item indented" v-if="props.data.editRolePermissions">
        <span>Edit role permissions</span>
        <div v-if="props.data.teamSettings.permission === 100">
          <Switch v-if="props.canEdit" :checked="props.data.editRolePermissions.permission === 100"
            @click.native="switchItem(props.data, 'editRolePermissions.permission')" />
          <span v-else>{{ switchText(props.data.editRolePermissions.permission) }}</span>
        </div>
      </div>

      <div class="setting-item indented" v-if="props.data.createAndEditAndManageCustomRoles">
        <span>Create, edit and manage company/team</span>
        <div v-if="props.data.teamSettings.permission === 100">
          <Switch v-if="props.canEdit" :checked="props.data.createAndEditAndManageCustomRoles.permission === 100"
            @click.native="switchItem(props.data, 'createAndEditAndManageCustomRoles.permission')" />
          <span v-else>{{ switchText(props.data.createAndEditAndManageCustomRoles.permission) }}</span>
        </div>
      </div>
  </div>
</template>

<script setup>
import { reactive } from 'vue';
import Switch from '@/components/ui/Switch.vue';
import { ElSelect, ElOption } from 'element-plus';
import { useTeamFunction } from './teamFunction';

const props = defineProps({
  data: {
    type: Object,
    default: () => ({})
  },
  isOwner: {
    type: Boolean,
    default: false
  },
  canEdit: {
    type: Boolean,
    default: false
  }
});
const { switchItem,switchText,switchParentText } = useTeamFunction();
//+++++++++++++++++++++++++++++
const handleManageChange = (event) => {
  props.data.editCompanyNameAndLogo.permission = event;
};
const handleTeamChange = (event) => {
  props.data.inviteTeammates.permission = event;
  props.data.assignRoleAndCompanyOrTeamToTeammates.permission = event;
  props.data.manageTeammates.permission = event;
  props.data.createAndEditAndManageCustomCompanyOrTeam.permission = event;
  props.data.editRolePermissions.permission = event;
  props.data.createAndEditAndManageCustomRoles.permission = event;
};
</script>
